import { request } from './http';
import type {
  LoginRequest,
  LoginResponse,
  RegisterRequest,
  UserProfile,
} from '@/types/user';

export const authApi = {
  /** 登录 */
  login(payload: LoginRequest) {
    return request<LoginResponse>({ url: '/auth/login', method: 'POST', data: payload });
  },
  /** 邀请注册 */
  register(payload: RegisterRequest) {
    return request<LoginResponse>({ url: '/auth/register', method: 'POST', data: payload });
  },
  /** 登出 */
  logout() {
    return request<void>({ url: '/auth/logout', method: 'POST' });
  },
  /** 当前登录用户 */
  me() {
    return request<UserProfile>({ url: '/auth/me', method: 'GET' });
  },
  /** 修改密码 */
  changePassword(payload: { oldPassword: string; newPassword: string }) {
    return request<void>({ url: '/auth/password', method: 'PUT', data: payload });
  },
  /** 更新联系信息 / 个人资料 */
  updateContact(payload: {
    email?: string;
    phone?: string;
    displayName?: string;
    legalName?: string;
    addressLine?: string;
  }) {
    return request<UserProfile>({ url: '/auth/profile', method: 'PUT', data: payload });
  },
  /** 更新创建邀请码时使用的默认下游费率 */
  updateDefaultDownstreamFees(payload: {
    depositFeeRateBps: number;
    cardOpenFeeCents: number;
  }) {
    return request<UserProfile>({
      url: '/auth/default-downstream-fees',
      method: 'PUT',
      data: payload,
    });
  },
  /** 二次安全验证：用支付密码换取一次性 step-up token */
  stepUp(payload: { payPassword: string; scenario: string }) {
    return request<{ token: string; expiresIn: number }>({
      url: '/auth/step-up',
      method: 'POST',
      data: payload,
    });
  },
};
